export default __webpack_public_path__ + "static/flag-de-4b8eb766d26d6ddad60daf3df8cdbdc9.svg";